import React, { Component } from 'react';
import styled from 'styled-components';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Sector
} from 'recharts';
import get from 'lodash/get';

const PieGraphContainer = styled.div`
  .rc-tooltip {
    opacity: 1;
  }
`;

const TooltipContainer = styled.div`
  padding: 10px;
  min-width: 200px;
  background-color: white;
  display: flex;
  flex-direction: column;

  .tooltipHeader {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
    margin-bottom: 10px;
  }

  .tooltipTitle {
    text-transform: uppercase;
    color: #adb5bd;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    font-family: ${(props) => props.theme.fonts.oswald};
  }

  .tooltipPercentage {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-weight: 600;
    font-size: 12px;
    color: ${(props) => props.theme.colors['terra-cotta']};
    margin-left: auto;
  }

  .tooltipSubContainer {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
  }

  .tooltipSubName {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    color: #4b4b4b;
  }

  .tooltipSubValue {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-weight: 600;
    font-size: 12px;
    color: #4b4b4b;
    margin-left: auto;
  }
`;

class PieGraph extends Component {
  constructor(props) {
    super(props);
    this.state = { hovering: false, activeIndex: null, coordinates: null };
  }

  handleMouverOver(props, index) {
    this.setState({
      hovering: get(props, 'name'),
      activeIndex: index,
      coordinates: get(props, 'tooltipPosition')
    });
  }

  renderTooltip() {
    const { tooltip, data, subKeyTooltip } = this.props;
    const { coordinates, activeIndex } = this.state;
    const activeData = data[activeIndex];
    return (
      activeData && (
        <Tooltip
          active
          content={
            <div
              className={`rc-tooltip overlayTooltip 
              rc-tooltip-placement-right
          rc-tooltip-inner`}
            >
              <div className="rc-tooltip-content">
                <div className="rc-tooltip-arrow" />
                <div className="rc-tooltip-inner" role="tooltip">
                  <TooltipContainer>
                    <div className="tooltipHeader">
                      <h3 className="tooltipTitle">{activeData.name}</h3>
                      <p className="tooltipPercentage">
                        {activeData.percentage}
                      </p>
                    </div>
                    {activeData[subKeyTooltip] &&
                      activeData[subKeyTooltip].length &&
                      activeData[subKeyTooltip].map((subItem) => (
                        <div key={subItem.name} className="tooltipSubContainer">
                          <p className="tooltipSubName">{subItem.name}</p>
                          <p className="tooltipSubValue">{subItem.value}</p>
                        </div>
                      ))}
                  </TooltipContainer>
                </div>
              </div>
            </div>
          }
          cursor={false}
          position={{
            x: coordinates.x,
            y:
              coordinates.y - 20 - 7 * get(activeData, subKeyTooltip, []).length
          }}
          {...tooltip}
        />
      )
    );
  }

  renderActiveShape(props) {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill
    } = props;

    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const mx = cx + (innerRadius + 2) * cos;
    const my = cy + (innerRadius + 2) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 2;
    const ey = my;

    return (
      <Sector
        cx={ex + (cos >= 0 ? 1 : -1) * 2}
        cy={ey}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 20}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    );
  }

  render() {
    const { data, height } = this.props;
    const { hovering, activeIndex } = this.state;
    const COLORS = ['#293442', '#525d69', '#7b838b', '#a4abae', '#d0d4d3'];

    return (
      <PieGraphContainer>
        <ResponsiveContainer height={height ? height : 350} width="100%">
          <PieChart>
            {' '}
            {hovering && this.renderTooltip(data)}
            <Pie
              onMouseOver={(props, index) =>
                this.handleMouverOver(props, index)
              }
              paddingAngle={0}
              onMouseOut={() =>
                this.setState({ hovering: false, activeIndex: null })
              }
              activeIndex={activeIndex}
              activeShape={(props) => this.renderActiveShape(props)}
              data={data}
              labelLine={true}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </PieGraphContainer>
    );
  }
}

export default PieGraph;
